<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>sync</mat-icon></div>
    <div>
      <span>Sincronizar todos con Bookcit</span>
      <small class="dlg-hdr__sub">Empleados activos</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="cancel()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">

  <ng-container *ngIf="loading">
    <div class="bbs-loading">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading">

    <div class="bbs-info">
      <mat-icon>info</mat-icon>
      <span>Selecciona las ubicaciones donde estarán disponibles <strong>todos los empleados activos</strong>.</span>
    </div>

    <div class="bbs-section-label">Ubicaciones</div>

    <p *ngIf="rows.length === 0" class="bbs-empty">No hay ubicaciones de Bookcit configuradas.</p>

    <div *ngFor="let row of rows" class="bbs-loc-row">
      <mat-checkbox [(ngModel)]="row.checked" [name]="'loc-' + row.locationId">
        {{ row.name }}
      </mat-checkbox>
      <app-select *ngIf="row.checked" class="bbs-role-field" [(ngModel)]="row.title" [name]="'role-' + row.locationId"
        [config]="{ label: 'Rol', options: titleOptions }"></app-select>
    </div>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="cancel()" [disabled]="saving">Cancelar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="save()" [disabled]="saving || loading">
    <mat-icon *ngIf="!saving">sync</mat-icon>
    <mat-progress-spinner *ngIf="saving" mode="indeterminate" diameter="18" style="display:inline-block"></mat-progress-spinner>
    <span>{{ saving ? 'Sincronizando...' : 'Sincronizar todos' }}</span>
  </button>
</mat-dialog-actions>
